module.exports = __webpack_public_path__ + "static/media/Level-3.b42814c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Level-3.svg
// module id = 1271
// module chunks = 0